import {
  BOX_PLOT_DEFAULT_BORDER_WIDTH,
  BOX_PLOT_HIGHLIGHTED_BORDER_WIDTH,
  DEFAULT_OPACITY
} from "constants/chart.constants";
import { EvaSeriesKind } from "constants/charts.enums";
import { SeriesOption } from "echarts";
import { SeriesType } from "types/echarts";
import { EvaChartStates } from "types/factory";

import { UNFOCUSED_OPACITY } from "components/multiphase-chart/constants/shared.constants";

export function boxPlotHighlightedOptions(states: Partial<EvaChartStates>) {
  const { chartOptions, hoverLegendItem, selectedGroups = [] } = states;

  if (!chartOptions?.series) {
    return {};
  }

  const isOpaque = !(hoverLegendItem || selectedGroups.length > 0);
  const series = chartOptions?.series as SeriesOption[];

  const boxPlotSeries = chartOptions.series[0]; // Assuming the first series is the box plot
  if (boxPlotSeries?.type !== SeriesType.BoxPlot || !boxPlotSeries.data) {
    return {};
  }

  boxPlotSeries.data.forEach((dataItem) => {
    const { name } = dataItem;
    const isHovered = hoverLegendItem === name || selectedGroups.includes(name);
    dataItem.itemStyle.opacity = isOpaque
      ? DEFAULT_OPACITY
      : isHovered
      ? DEFAULT_OPACITY
      : UNFOCUSED_OPACITY;
    dataItem.itemStyle.borderWidth = isHovered
      ? BOX_PLOT_HIGHLIGHTED_BORDER_WIDTH
      : BOX_PLOT_DEFAULT_BORDER_WIDTH;
  });

  const customOptions = series
    .filter((option) => option.type === "custom")
    .map((option) => ({ id: option.id }));

  // Preserve type well series fully to prevent them from disappearing
  const typeWellSeries = series.filter(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (option: any) => option.kind === EvaSeriesKind.TypeWell
  );

  const result = [boxPlotSeries, ...customOptions, ...typeWellSeries];

  return result;
}
